import { render, staticRenderFns } from "./InventBomVersionSearch.vue?vue&type=template&id=3bf6f73a"
import script from "./InventBomVersionSearch.vue?vue&type=script&lang=js"
export * from "./InventBomVersionSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports